const emailDataUpdateFormatter = (data, currentForm) => {
  const dataSet = data?.data || data;
  if (dataSet["id"]) {
    currentForm["phone_id"] = dataSet["id"];
    currentForm["placeholder_phone"] = dataSet["number"];
  }
  return currentForm;
};

export default emailDataUpdateFormatter;
